import Image from 'next/image';
import type { LibraryMaterial } from '@/lib/library/materials';

/**
 * Превью первой страницы материала: контейнер 3:4, обрезка по верху.
 * Настоящая страница файла вместо иллюстраций (спека §12, §25).
 */
export function MaterialThumb({
  material,
  sizes,
  priority = false,
  className = '',
}: {
  material: LibraryMaterial;
  sizes: string;
  priority?: boolean;
  className?: string;
}) {
  return (
    <div
      className={`relative aspect-[3/4] overflow-hidden rounded-[10px] border border-graphite-8 bg-cream-100 ${className}`}
    >
      <Image
        src={material.preview.src}
        alt={material.preview.alt}
        fill
        sizes={sizes}
        priority={priority}
        className="object-cover object-top"
      />
    </div>
  );
}
